import { VideoLinkDto } from '@app/data/dtos/multimedia/video/video.dto';
import { VideoProviderTypes } from '@app/entities/enums/media-player/media-player.enum';
import { ContentType, PublicationContentType } from '@app/entities/enums/multimedia/content-status-types.enum';
import { VimeoStatus } from '@app/entities/enums/vimeo/vimeo-status.enum';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { applyMixins } from '@shared/utils/utils';

import { AbstractMultimediaItem } from './multimedia.abstract.model';
import { Publication } from './publication.model';
import { VideoQualities, getVideoQualities } from './video-qualities.model';

export abstract class Video extends AbstractMultimediaItem {
  abstract contentType: PublicationContentType.VIDEO | ContentType.VIDEO;
  idVideo?: string;
  statusUpload!: string;
  videoProvider?: VideoProviderTypes;
  vimeoStatus?: VimeoStatus;
  videoImage?: string;
  qualities?: VideoQualities[];
  subtitles!: string;
  thumbnail!: string;

  init(data: MSafeAny) {
    this.idVideo = data.idVideo || data.videoId;
    this.statusUpload = data.statusUpload;
    this.vimeoStatus = data.vimeoStatus;
    this.videoImage = data.videoImage;
    this.subtitles = data.subtitles;
    this.url = data.url;
    this.qualities = getVideoQualities(data.videos);
  }

  isTranscoding(): boolean {
    return this.vimeoStatus === VimeoStatus.TRANSCODING || this.vimeoStatus === VimeoStatus.TRANSCODE_STARTING;
  }

  isAvailable(): boolean {
    return this.vimeoStatus === VimeoStatus.AVAILABLE;
  }

  hasProvider(type: VideoProviderTypes): boolean {
    return this.videoProvider === type;
  }
}

export class VideoPublication extends Publication implements Video {
  contentType: PublicationContentType.VIDEO = PublicationContentType.VIDEO;
  idVideo!: string | undefined;
  statusUpload!: string;
  videoProvider: VideoProviderTypes | undefined;
  vimeoStatus!: VimeoStatus | undefined;
  videoImage!: string | undefined;
  subtitles!: string;
  thumbnail!: string;
  init!: (data: MSafeAny) => void;
  isTranscoding!: () => boolean;
  isAvailable!: () => boolean;
  hasProvider!: (type: VideoProviderTypes) => boolean;

  constructor(data: MSafeAny) {
    super(data);
    this.init(data);
    this.videoProvider = data.videoProvider || VideoProviderTypes.VIMEO;
  }
}

export class BoardingVideo extends Publication implements Video {
  contentType: PublicationContentType.VIDEO = PublicationContentType.VIDEO;
  statusUpload!: string;
  videoProvider = VideoProviderTypes.VIMEO;
  subtitles!: string;
  thumbnail: string;
  videoImage: string;
  init!: (data: MSafeAny) => void;
  isTranscoding!: () => boolean;
  isAvailable!: () => boolean;
  hasProvider!: (type: VideoProviderTypes) => boolean;

  constructor(data: MSafeAny) {
    super(data);
    this.url = data.url;
    this.thumbnail = data.thumbnail;
    this.videoImage = data.thumbnail;
  }
}

applyMixins(VideoPublication, [Video]);
applyMixins(BoardingVideo, [Video]);

export class PrivateVideo {
  videoProvider!: string;
  videoImage!: string;
  videos!: VideoLinkDto[];
  url!: string;
  idVideo!: string;
  title!: string;
}
